import { authenticateConstants } from "./constants/authenticateConstants";
import { getDatesAPIAction } from "./reducers/apiReducers/getDatesReducer";
import { authenticateService } from "./services/authenticateService";

export const authenticateActions = {
  retrieve
};

function retrieve() {
  return (dispatch) => {
    dispatch(request());
    authenticateService.retrieve().then((response) => {
      if (response && typeof response === "object" && !response.error) {
        dispatch(success(response));
        dispatch(getDatesAPIAction("en"));
        dispatch(getDatesAPIAction("fr"));
      } else {
        dispatch(error());
      }
    });
  };

  function request() {
    return { type: authenticateConstants.AUTH_REQUEST };
  }

  function success(data) {
    return { type: authenticateConstants.AUTH_SUCCESS, data };
  }

  function error() {
    return { type: authenticateConstants.AUTH_ERROR };
  }
}
